import { post } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'

type ImportFieldValidationResponseModelDTO = {
  valid: boolean
  message: string
}

export function useValidateUniqueImportName() {
  const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.validateName}`

  return async (
    name: string,
  ): Promise<ImportFieldValidationResponseModelDTO> => {
    const response = await post(url, name)
    const data: Promise<ImportFieldValidationResponseModelDTO> =
      await response.json()
    return data
  }
}
